import "./polyfill";
import $ from "jquery";
import "picturefill";
import { ViewMore } from "./endocrine/ViewMore";
import { ViewLarger } from "./endocrine/ViewLarger";
import { HeaderSubscribe } from "./endocrine/HeaderSubscribe";

import { PrimaryNav } from "./endocrine/navigation/PrimaryNav";
import { ViewAllExpand } from "./endocrine/ViewAllExpand";
import { SecondaryNav } from "./endocrine/navigation/SecondaryNav";
import { BackToTop } from "./endocrine/BackToTop";
import { MagicNav } from "./endocrine/navigation/MagicNav";
import { Hamburger } from "./endocrine/navigation/Hamburger";
import { SimpleNavTrigger } from "./endocrine/navigation/SimpleNavTrigger";
import richText from "./endocrine/richText.js";

// view more text
if ($(".js-more-text").length) {
    const viewMore = $.makeArray($(".js-more-text")).map(el => {
        return new ViewMore($(el));
    });
}

// header subscribe
if ($(".js-newsletter-signup").length) {
    const headerSubscribe = $.makeArray($(".js-newsletter-signup")).map(el => {
        return new HeaderSubscribe($(el));
    });
}

richText();

// PrimaryNav
const $primaryNavEl = $(".js-primary-nav");
if ($primaryNavEl.length) {
    let primaryNav = new PrimaryNav($primaryNavEl);
}

// Hamburger
const $hamburger = $(".js-hamburger");
if ($hamburger.length) {
    let hamburger = new Hamburger($hamburger, false, true);
}

// SimpleNavTrigger
const $simplenav = $(".js-simple-nav");
if ($simplenav.length) {
    const simplenav = $.makeArray($(".js-simple-nav")).map(el => {
        return new SimpleNavTrigger($(el));
    });
}

// Global Nav
const $globalnav = $(".js-magic-nav");
if ($globalnav.length) {
    const globalnav = $.makeArray($globalnav).map(el => {
        return new MagicNav($(el));
    });
}

// Expandable Listings
const viewAllables = $.makeArray($(".js-view-all-expand")).map(el => {
    return new ViewAllExpand($(el));
});

// Secondary Nav
if ($(".js-secondary-nav").length) {
    const secondaryNav = new SecondaryNav($(".js-secondary-nav"));
}

// back to top button
if ($(".js-back-to-top").length) {
    const backToTop = $.makeArray($(".js-back-to-top")).map(el => {
        return new BackToTop($(el));
    });
}

// view images/infographics larger in a modal
if ($(".js-image-block-zoomed").length) {
    const viewLarger = $.makeArray($(".js-image-block-zoomed")).map(el => {
        return new ViewLarger($(el));
    });
}

// view more text
if ($(".js-more-text").length) {
    const viewMore = $.makeArray($(".js-more-text")).map(el => {
        return new ViewMore($(el));
    });
}

$(document).ready(function() {});
